/* Collection frame colour picker — snippets/collection-frame-picker.liquid.
   Sets data-frame on every composited card (.pf) in the collection grid, including
   cards added later ("Vis flere", facets), and remembers the choice for the visit. */
(() => {
  if (window.__cfpReady) return;
  window.__cfpReady = true;

  const STORE = 'pf:collection-frame';
  const read = () => { try { return sessionStorage.getItem(STORE); } catch (e) { return null; } };
  const write = (k) => { try { sessionStorage.setItem(STORE, k); } catch (e) { /* private mode */ } };

  const pickers = () => document.querySelectorAll('[data-cfp]');
  const validKeys = () => {
    const p = pickers()[0];
    return p ? [...p.querySelectorAll('[data-cfp-key]')].map((b) => b.dataset.cfpKey) : [];
  };

  let current = null;

  function applyTo(root) {
    if (!current) return;
    root.querySelectorAll('.pf[data-pf]:not([data-pf-switch])').forEach((el) => {
      if (el.closest('[data-cfp-scope], #product-grid-ajax, .collection')) el.setAttribute('data-frame', current);
    });
  }

  function sync() {
    pickers().forEach((p) => p.querySelectorAll('[data-cfp-key]').forEach((b) => {
      const on = b.dataset.cfpKey === current;
      b.setAttribute('aria-checked', on ? 'true' : 'false');
      b.tabIndex = on ? 0 : -1;
      if (on) mirror(p, b);
    }));
  }

  // Mobile toggle shows the selected frame's chip (colour + moulding texture).
  function mirror(p, b) {
    const t = p.querySelector('[data-cfp-toggle]');
    if (!t) return;
    t.style.setProperty('--cfp-colour', b.style.getPropertyValue('--cfp-colour'));
    const from = b.querySelector('.cfp__corner');
    const to = t.querySelector('.cfp__corner');
    const tex = from && from.style.getPropertyValue('--cfp-texture');
    if (to) to.style.setProperty('--cfp-texture', tex || '');
  }

  // ---- Mobile menu (toggle + popover). Desktop never shows the toggle. ----
  function setOpen(p, open, focus) {
    const t = p.querySelector('[data-cfp-toggle]');
    if (!t) return;
    p.classList.toggle('is-open', open);
    t.setAttribute('aria-expanded', open ? 'true' : 'false');
    if (open && focus) {
      const sel = p.querySelector('[data-cfp-key][aria-checked="true"]') || p.querySelector('[data-cfp-key]');
      if (sel) sel.focus();
    } else if (!open && focus) {
      t.focus();
    }
  }
  const closeAll = (except) => pickers().forEach((p) => { if (p !== except && p.classList.contains('is-open')) setOpen(p, false, false); });

  function select(key, persist) {
    if (!validKeys().includes(key)) return;
    current = key;
    if (persist) write(key);
    applyTo(document);
    sync();
  }

  // Paint each chip's corner with the frame's real moulding texture (its overlay image).
  function paint() {
    const P = window.PeletonFrames;
    if (!P) return;
    document.querySelectorAll('[data-cfp] [data-cfp-key]').forEach((b) => {
      const f = P.get(b.dataset.cfpKey);
      const corner = b.querySelector('.cfp__corner');
      if (f && f.overlay && corner) corner.style.setProperty('--cfp-texture', `url("${f.overlay}")`);
    });
  }

  // Desktop: sit just left of the sort dropdown that shares the grid cell.
  function place() {
    pickers().forEach((p) => {
      const sort = p.parentElement && p.parentElement.querySelector('.sort-by');
      if (sort) p.style.setProperty('--cfp-offset', `${Math.ceil(sort.getBoundingClientRect().width)}px`);
    });
  }

  function init() {
    const first = pickers()[0];
    if (!first) return;
    paint();
    place();
    window.addEventListener('resize', place, { passive: true });
    if (document.fonts && document.fonts.ready) document.fonts.ready.then(place);
    const stored = read();
    select(validKeys().includes(stored) ? stored : first.dataset.default || validKeys()[0], false);

    document.addEventListener('click', (e) => {
      const t = e.target.closest('[data-cfp-toggle]');
      if (t) {
        const p = t.closest('[data-cfp]');
        closeAll(p);
        setOpen(p, !p.classList.contains('is-open'), e.detail === 0);
        return;
      }
      const b = e.target.closest('[data-cfp] [data-cfp-key]');
      if (b) {
        select(b.dataset.cfpKey, true);
        const p = b.closest('[data-cfp]');
        if (p.classList.contains('is-open')) setOpen(p, false, e.detail === 0);
        return;
      }
      // Outside tap closes an open menu.
      if (!e.target.closest('[data-cfp]')) closeAll(null);
    });
    document.addEventListener('keydown', (e) => {
      if (e.key === 'Escape') {
        const p = [...pickers()].find((x) => x.classList.contains('is-open'));
        if (p) { e.preventDefault(); setOpen(p, false, true); }
        return;
      }
    });
    document.addEventListener('keydown', (e) => {
      const b = e.target.closest && e.target.closest('[data-cfp] [data-cfp-key]');
      if (!b || !['ArrowRight', 'ArrowLeft', 'ArrowDown', 'ArrowUp'].includes(e.key)) return;
      e.preventDefault();
      const all = [...b.parentElement.querySelectorAll('[data-cfp-key]')];
      const fwd = e.key === 'ArrowRight' || e.key === 'ArrowDown';
      const next = all[(all.indexOf(b) + (fwd ? 1 : all.length - 1)) % all.length];
      select(next.dataset.cfpKey, true);
      next.focus();
    });

    // Cards inserted later (load more, facet/sort re-render) get the chosen frame too.
    new MutationObserver((records) => {
      for (const r of records) r.addedNodes.forEach((n) => { if (n.nodeType === 1) applyTo(n.parentElement || n); });
    }).observe(document.body, { childList: true, subtree: true });
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();
})();
